module.exports = __webpack_public_path__ + "img/tongcheng_icon.3d5ff867.png";